<template>
    <v-bottom-navigation class="app-bottom-bar" v-if="isAuthenticated" app fixed>
        <v-btn to="/home" @click="closePanels">
            <span class="white--text">Home</span>
            <v-icon small color="#ffffff">mdi-home</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="handleMapClick">
            <span class="white--text">Geofence</span>
            <v-icon small color="#ffffff">mdi-map-marker-radius</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn to="/settings" @click="closePanels">
            <span class="white--text">Settings</span>
            <v-icon small color="#ffffff">mdi-cog</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn to="/event-log" @click="closePanels">
            <span class="white--text">Event log</span>
            <v-icon small :color="alarmColor" @click="dismissAlarmMode">mdi-alert-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn to="/weather" @click="closePanels">
            <span class="white--text">Weather</span>
            <v-icon small color="#ffffff">mdi-white-balance-sunny</v-icon>
        </v-btn>
    </v-bottom-navigation>
</template>
<script lang="ts">
    import { defineComponent, computed, getCurrentInstance } from "vue";
    import Vue from "vue";
    import { alarm, app } from "@/store";
    import { OidcAuth } from "vue-oidc-client/vue2";
    import {
        resolveGeolocationAccess,
    } from "@/utilities/useGeolocation";

    export default defineComponent({
        setup() {
            const root = getCurrentInstance()?.proxy as any;
            const isAuthenticated = computed(() =>
                Vue.prototype.$oidc
                    ? (Vue.prototype.$oidc as OidcAuth).isAuthenticated
                    : false
            );

            const goToMap = async () => {
                if (root.$route.path !== "/map" && root.$route.path !== "/geo-permission") {
                    const accessResolution = await resolveGeolocationAccess();
                    console.info("[GeoTrace] FooterNavigation.goToMap resolved permission state", {
                        permissionState: accessResolution.permissionState,
                        accessStatus: accessResolution.accessStatus,
                        route: root.$route.path,
                    });

                    if (accessResolution.accessStatus === "denied" || accessResolution.accessStatus === "unavailable") {
                        root.$router.push({ name: "geo-permission", query: { destination: "map" } });
                        return;
                    }

                    if (accessResolution.accessStatus === "granted") {
                        root.$router.push({ name: "map" });
                    } else {
                        root.$router.push({ name: "geo-permission", query: { destination: "map" } });
                    }
                }
            };

            const closePanels = () => {
                app.setHomePanelOpen(false);
                app.setHomePanelIndex(-1);
                app.setMyBoatPanelOpen(false);
                app.setMyBoatPanelIndex(-1);
                app.setControlPanelOpen(false);
                app.setControlPanelIndex(-1);
                app.setSensorsPanelOpen(false);
                app.setSensorsPanelIndex(-1);
            };

            const handleMapClick = () => {
                closePanels();
                goToMap();
            };

            const dismissAlarmMode = () => {
                alarm.setInAlarmMode(false);
            };

            const isAlarm = computed<boolean>(() => {
                return alarm.inAlarmMode;
            });

            const alarmColor = computed(() => {
                if (isAlarm.value) {
                    return "#FF0000"
                } else {
                    return "#FFFFFF"
                }
            });

            return {
                isAuthenticated,
                goToMap,
                closePanels,
                handleMapClick,
                alarmColor,
                dismissAlarmMode
            };
        }
    });
</script>

<style lang="scss" scoped>
    .app-bottom-bar {
        border-top-color: #fff;
        border-top-style: solid;
        border-top-width: 1px;
        background-color: #242021 !important;

        .spacer {
            flex-grow: 0 !important;
            background-color: #00aa87;
            width: 2px;
            margin: 20px 0 20px 0;
        }
    }
</style>